import { useLocalization } from '@fluent/react';

import AppContainerLayout from '#/layouts/AppContainerLayout';
import AddUserPanel from '#/components/panels/AddUserPanel';

const UserDetailsPage = () => {
  const { l10n } = useLocalization();

  return (
    <AppContainerLayout>
      <div className="w-full min-h-screen p-8 bg-blue-100">
        <h2 className="text-black pb-4">{l10n.getString('add-new-user')}</h2>
        <div className="flex-col  min-h-screen bg-white p-8 rounded-lg pt-10">
          <AddUserPanel />
        </div>
      </div>
    </AppContainerLayout>
  );
};

export default UserDetailsPage;
